import { WidgetApiServiceTypes } from '@/types/widgetApiService';
export var CountryTypes;
(function (CountryTypes) {
    var ChannelTypes = WidgetApiServiceTypes.ChannelTypes;
    let CountryCodes;
    (function (CountryCodes) {
        CountryCodes["NIGERIA"] = "NG";
        CountryCodes["SOUTH_AFRICA"] = "ZA";
        CountryCodes["KENYA"] = "KE";
        CountryCodes["ZAMBIA"] = "ZM";
        CountryCodes["CAMEROON"] = "CM";
        CountryCodes["MALAWI"] = "MW";
        CountryCodes["GABON"] = "GA";
        CountryCodes["RWANDA"] = "RW";
        CountryCodes["IVORY_COAST"] = "CI";
        CountryCodes["CONGO"] = "CG";
        CountryCodes["BENIN"] = "BJ";
        CountryCodes["SENEGAL"] = "SN";
        CountryCodes["MALI"] = "ML";
        CountryCodes["BOTSWANA"] = "BW";
        CountryCodes["BURKINA_FASO"] = "BF";
        CountryCodes["UGANDA"] = "UG";
        CountryCodes["TANZANIA"] = "TZ";
        CountryCodes["TOGO"] = "TG";
        CountryCodes["DEMOCRATIC_REPUBLIC_OF_CONGO"] = "CD";
    })(CountryCodes = CountryTypes.CountryCodes || (CountryTypes.CountryCodes = {}));
    let Countries;
    (function (Countries) {
        Countries["NIGERIA"] = "Nigeria";
        Countries["SOUTH_AFRICA"] = "South Africa";
        Countries["KENYA"] = "Kenya";
        Countries["ZAMBIA"] = "Zambia";
        Countries["CAMEROON"] = "Cameroon";
        Countries["MALAWI"] = "Malawi";
        Countries["GABON"] = "Gabon";
        Countries["RWANDA"] = "Rwanda";
        Countries["IVORY_COAST"] = "Ivory Coast";
        Countries["CONGO"] = "Congo";
        Countries["BENIN"] = "Benin";
        Countries["SENEGAL"] = "Senegal";
        Countries["MALI"] = "Mali";
        Countries["BOTSWANA"] = "Botswana";
        Countries["BURKINA_FASO"] = "Burkina Faso";
        Countries["UGANDA"] = "Uganda";
        Countries["TANZANIA"] = "Tanzania";
        Countries["TOGO"] = "Togo";
        Countries["DEMOCRATIC_REPUBLIC_OF_CONGO"] = "Congo, The Democratic Republic of the Congo";
    })(Countries = CountryTypes.Countries || (CountryTypes.Countries = {}));
    let IdTypes;
    (function (IdTypes) {
        IdTypes["NIN"] = "NIN Slip/Card";
        IdTypes["BVN"] = "BVN";
        IdTypes["ID_CARD"] = "ID Card";
        IdTypes["ID_BOOK"] = "ID Book";
        IdTypes["NATIONAL_ID"] = "National ID";
        IdTypes["ALIEN_CARD"] = "Alien Card";
        IdTypes["PASSPORT"] = "Passport";
        IdTypes["ECOWAS_ID"] = "Ecowas Card";
        IdTypes["RWANDA_CARD"] = "Rwanda Card";
    })(IdTypes = CountryTypes.IdTypes || (CountryTypes.IdTypes = {}));
    let IdCaptureType;
    (function (IdCaptureType) {
        IdCaptureType["NO_CAPTURE"] = "no_capture";
        IdCaptureType["FRONT"] = "front";
        IdCaptureType["FRONT_AND_BACK"] = "front_and_back";
    })(IdCaptureType = CountryTypes.IdCaptureType || (CountryTypes.IdCaptureType = {}));
    CountryTypes.SupportedCountriesConfig = {
        NG: {
            countryCode: CountryCodes.NIGERIA,
            currency: 'NGN',
            countryName: Countries.NIGERIA,
            idTypes: [
                { value: IdTypes.NIN, label: IdTypes.NIN },
                { value: IdTypes.BVN, label: IdTypes.BVN },
            ],
            providers: [ChannelTypes.P2P],
            phoneValidation: {
                MIN_PHONE_LENGTH: 10,
                MAX_PHONE_LENGTH: 11,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.NIN,
                    regex: '^[0-9]{11}$',
                    captureType: IdCaptureType.NO_CAPTURE,
                },
                {
                    idType: IdTypes.BVN,
                    regex: '^[0-9]{11}$',
                    captureType: IdCaptureType.NO_CAPTURE,
                },
            ],
        },
        ZA: {
            countryCode: CountryCodes.SOUTH_AFRICA,
            currency: 'ZAR',
            countryName: Countries.SOUTH_AFRICA,
            idTypes: [
                { value: IdTypes.ID_CARD, label: IdTypes.ID_CARD },
                { value: IdTypes.ID_BOOK, label: IdTypes.ID_BOOK },
            ],
            providers: [ChannelTypes.BANK, ChannelTypes.EFT],
            phoneValidation: {
                MIN_PHONE_LENGTH: 9,
                MAX_PHONE_LENGTH: 10,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.ID_CARD,
                    regex: '^[0-9]{13}$',
                    captureType: IdCaptureType.FRONT_AND_BACK,
                },
                {
                    idType: IdTypes.ID_BOOK,
                    regex: '^[0-9]{13}$',
                    captureType: IdCaptureType.FRONT,
                },
            ],
        },
        KE: {
            countryCode: CountryCodes.KENYA,
            currency: 'KES',
            countryName: Countries.KENYA,
            idTypes: [
                { value: IdTypes.NATIONAL_ID, label: IdTypes.NATIONAL_ID },
                { value: IdTypes.ALIEN_CARD, label: IdTypes.ALIEN_CARD },
            ],
            providers: [ChannelTypes.MOMO],
            phoneValidation: {
                MIN_PHONE_LENGTH: 9,
                MAX_PHONE_LENGTH: 10,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.NATIONAL_ID,
                    regex: '^[0-9]{1,9}$',
                    captureType: IdCaptureType.FRONT_AND_BACK,
                },
                {
                    idType: IdTypes.ALIEN_CARD,
                    regex: '^[0-9]{6,9}$',
                    captureType: IdCaptureType.FRONT_AND_BACK,
                },
            ],
        },
        ZM: {
            countryCode: CountryCodes.ZAMBIA,
            currency: 'ZMW',
            countryName: Countries.ZAMBIA,
            idTypes: [{ value: IdTypes.PASSPORT, label: IdTypes.PASSPORT }],
            providers: [ChannelTypes.BANK, ChannelTypes.MOMO],
            phoneValidation: {
                MIN_PHONE_LENGTH: 9,
                MAX_PHONE_LENGTH: 10,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.PASSPORT,
                    regex: '.+',
                    captureType: IdCaptureType.FRONT,
                },
            ],
        },
        CM: {
            countryCode: CountryCodes.CAMEROON,
            currency: 'XAF',
            countryName: Countries.CAMEROON,
            idTypes: [
                { value: IdTypes.NATIONAL_ID, label: IdTypes.NATIONAL_ID },
                { value: IdTypes.PASSPORT, label: IdTypes.PASSPORT },
            ],
            providers: [ChannelTypes.MOMO],
            phoneValidation: {
                MIN_PHONE_LENGTH: 9,
                MAX_PHONE_LENGTH: 10,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.NATIONAL_ID,
                    regex: '^[0-9]{16}$',
                    captureType: IdCaptureType.FRONT_AND_BACK,
                },
                {
                    idType: IdTypes.PASSPORT,
                    regex: '^[a-zA-Z0-9\\-/\\s]+$',
                    captureType: IdCaptureType.FRONT,
                },
            ],
        },
        MW: {
            countryCode: CountryCodes.MALAWI,
            currency: 'MWK',
            countryName: Countries.MALAWI,
            idTypes: [
                { value: IdTypes.PASSPORT, label: IdTypes.PASSPORT },
                { value: IdTypes.NATIONAL_ID, label: IdTypes.NATIONAL_ID },
            ],
            providers: [ChannelTypes.MOMO, ChannelTypes.BANK],
            phoneValidation: {
                MIN_PHONE_LENGTH: 7,
                MAX_PHONE_LENGTH: 10,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.PASSPORT,
                    regex: '^M[A-Z0-9]{1,9}$',
                    regexFlag: 'i',
                    captureType: IdCaptureType.FRONT,
                },
                {
                    idType: IdTypes.NATIONAL_ID,
                    regex: '^[A-Za-z0-9]{6,10}$',
                    regexFlag: 'i',
                    captureType: IdCaptureType.FRONT,
                },
            ],
            manualBankSellDetails: true,
        },
        GA: {
            countryCode: CountryCodes.GABON,
            currency: 'XAF',
            countryName: Countries.GABON,
            idTypes: [{ value: IdTypes.PASSPORT, label: IdTypes.PASSPORT }],
            providers: [ChannelTypes.BANK],
            phoneValidation: {
                MIN_PHONE_LENGTH: 6,
                MAX_PHONE_LENGTH: 7,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.PASSPORT,
                    regex: '^[0-9]{2,4}GA[0-9]{4,6}',
                    captureType: IdCaptureType.FRONT,
                },
            ],
            manualBankSellDetails: true,
        },
        RW: {
            countryCode: CountryCodes.RWANDA,
            currency: 'RWF',
            countryName: Countries.RWANDA,
            idTypes: [
                { value: IdTypes.NATIONAL_ID, label: IdTypes.NATIONAL_ID },
                { value: IdTypes.RWANDA_CARD, label: IdTypes.RWANDA_CARD },
            ],
            providers: [ChannelTypes.MOMO, ChannelTypes.BANK],
            phoneValidation: {
                MIN_PHONE_LENGTH: 9,
                MAX_PHONE_LENGTH: 10,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.NATIONAL_ID,
                    regex: '^[a-zA-Z0-9\\-/\\s]+$',
                    captureType: IdCaptureType.FRONT,
                },
                {
                    idType: IdTypes.RWANDA_CARD,
                    regex: '^[0-9]{12,18}$',
                    captureType: IdCaptureType.FRONT,
                },
            ],
            manualBankSellDetails: true,
        },
        CI: {
            countryCode: CountryCodes.IVORY_COAST,
            currency: 'XOF',
            countryName: Countries.IVORY_COAST,
            idTypes: [
                { value: IdTypes.PASSPORT, label: IdTypes.PASSPORT },
                { value: IdTypes.NATIONAL_ID, label: IdTypes.NATIONAL_ID },
            ],
            providers: [ChannelTypes.MOMO],
            phoneValidation: {
                MIN_PHONE_LENGTH: 9,
                MAX_PHONE_LENGTH: 10,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.PASSPORT,
                    regex: '^[A-Za-z0-9]{8,11}$',
                    captureType: IdCaptureType.FRONT,
                },
                {
                    idType: IdTypes.NATIONAL_ID,
                    regex: '^CI[0-9]{9,12}$',
                    captureType: IdCaptureType.FRONT,
                },
            ],
        },
        CG: {
            countryCode: CountryCodes.CONGO,
            currency: 'XAF',
            countryName: Countries.CONGO,
            idTypes: [
                { value: IdTypes.PASSPORT, label: IdTypes.PASSPORT },
                { value: IdTypes.NATIONAL_ID, label: IdTypes.NATIONAL_ID },
            ],
            providers: [ChannelTypes.BANK],
            phoneValidation: {
                MIN_PHONE_LENGTH: 9,
                MAX_PHONE_LENGTH: 10,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.PASSPORT,
                    regex: '^OA[0-9]{6,10}$',
                    captureType: IdCaptureType.FRONT,
                },
                {
                    idType: IdTypes.NATIONAL_ID,
                    regex: '^[0-9]{10,14}$',
                    captureType: IdCaptureType.FRONT,
                },
            ],
            manualBankSellDetails: true,
        },
        BJ: {
            countryCode: CountryCodes.BENIN,
            currency: 'XOF',
            countryName: Countries.BENIN,
            idTypes: [
                { value: IdTypes.PASSPORT, label: IdTypes.PASSPORT },
                { value: IdTypes.NATIONAL_ID, label: IdTypes.NATIONAL_ID },
            ],
            providers: [ChannelTypes.MOMO],
            phoneValidation: {
                MIN_PHONE_LENGTH: 8,
                MAX_PHONE_LENGTH: 10,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.PASSPORT,
                    regex: '^[a-zA-Z0-9\\-/\\s]+$',
                    captureType: IdCaptureType.FRONT,
                },
                {
                    idType: IdTypes.NATIONAL_ID,
                    regex: '^[a-zA-Z0-9\\-/\\s]+$',
                    captureType: IdCaptureType.FRONT,
                },
            ],
        },
        BF: {
            countryCode: CountryCodes.BURKINA_FASO,
            currency: 'XOF',
            countryName: Countries.BURKINA_FASO,
            idTypes: [
                { value: IdTypes.PASSPORT, label: IdTypes.PASSPORT },
                { value: IdTypes.NATIONAL_ID, label: IdTypes.NATIONAL_ID },
            ],
            providers: [ChannelTypes.MOMO],
            phoneValidation: {
                MIN_PHONE_LENGTH: 7,
                MAX_PHONE_LENGTH: 8,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.PASSPORT,
                    regex: '^[a-zA-Z0-9\\-/\\s]+$',
                    captureType: IdCaptureType.FRONT,
                },
                {
                    idType: IdTypes.NATIONAL_ID,
                    regex: '^[a-zA-Z0-9\\-/\\s]+$',
                    captureType: IdCaptureType.FRONT,
                },
            ],
        },
        UG: {
            countryCode: CountryCodes.UGANDA,
            currency: 'UGX',
            countryName: Countries.UGANDA,
            idTypes: [{ value: IdTypes.NATIONAL_ID, label: IdTypes.NATIONAL_ID }],
            providers: [ChannelTypes.BANK],
            phoneValidation: {
                MIN_PHONE_LENGTH: 9,
                MAX_PHONE_LENGTH: 10,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.NATIONAL_ID,
                    regex: '^[A-Z0-9]{14}$',
                    regexFlag: 'i',
                    captureType: IdCaptureType.FRONT_AND_BACK,
                },
            ],
            manualBankSellDetails: true,
        },
        TZ: {
            countryCode: CountryCodes.TANZANIA,
            currency: 'TZS',
            countryName: Countries.TANZANIA,
            idTypes: [
                { value: IdTypes.PASSPORT, label: IdTypes.PASSPORT },
                { value: IdTypes.NATIONAL_ID, label: IdTypes.NATIONAL_ID },
            ],
            providers: [ChannelTypes.BANK, ChannelTypes.MOMO],
            phoneValidation: {
                MIN_PHONE_LENGTH: 9,
                MAX_PHONE_LENGTH: 10,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.PASSPORT,
                    regex: '^T[0-9A-Za-z]{6,10}$',
                    captureType: IdCaptureType.FRONT,
                },
                {
                    idType: IdTypes.NATIONAL_ID,
                    regex: '^[0-9]{20}$',
                    captureType: IdCaptureType.FRONT,
                },
            ],
        },
        TG: {
            countryCode: CountryCodes.TOGO,
            currency: 'XOF',
            countryName: Countries.TOGO,
            idTypes: [
                { value: IdTypes.PASSPORT, label: IdTypes.PASSPORT },
                { value: IdTypes.NATIONAL_ID, label: IdTypes.NATIONAL_ID },
            ],
            providers: [ChannelTypes.MOMO],
            phoneValidation: {
                MIN_PHONE_LENGTH: 8,
                MAX_PHONE_LENGTH: 9,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.PASSPORT,
                    regex: '^EB[0-9]{4,8}$',
                    captureType: IdCaptureType.FRONT,
                },
                {
                    idType: IdTypes.NATIONAL_ID,
                    regex: '^[0-9]{10,14}$',
                    captureType: IdCaptureType.FRONT,
                },
            ],
        },
        BW: {
            countryCode: CountryCodes.BOTSWANA,
            currency: 'BWP',
            countryName: Countries.BOTSWANA,
            idTypes: [{ value: IdTypes.NATIONAL_ID, label: IdTypes.NATIONAL_ID }],
            providers: [ChannelTypes.BANK],
            phoneValidation: {
                MIN_PHONE_LENGTH: 8,
                MAX_PHONE_LENGTH: 9,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.NATIONAL_ID,
                    regex: '^[0-9]{1,9}$',
                    captureType: IdCaptureType.FRONT_AND_BACK,
                },
            ],
        },
        SN: {
            countryCode: CountryCodes.SENEGAL,
            currency: 'XOF',
            countryName: Countries.SENEGAL,
            idTypes: [
                { value: IdTypes.NATIONAL_ID, label: IdTypes.NATIONAL_ID },
                { value: IdTypes.PASSPORT, label: IdTypes.PASSPORT },
                { value: IdTypes.ECOWAS_ID, label: IdTypes.ECOWAS_ID },
            ],
            providers: [ChannelTypes.MOMO],
            phoneValidation: {
                MIN_PHONE_LENGTH: 9,
                MAX_PHONE_LENGTH: 10,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.NATIONAL_ID,
                    regex: '^1[0-9]{14,18}$',
                    captureType: IdCaptureType.FRONT,
                },
                {
                    idType: IdTypes.PASSPORT,
                    regex: '^A+[0-9]{6,10}$',
                    captureType: IdCaptureType.FRONT,
                },
                {
                    idType: IdTypes.ECOWAS_ID,
                    regex: '^[0-9]{17}$',
                    captureType: IdCaptureType.FRONT,
                },
            ],
        },
        ML: {
            countryCode: CountryCodes.MALI,
            currency: 'XOF',
            countryName: Countries.MALI,
            idTypes: [
                { value: IdTypes.NATIONAL_ID, label: IdTypes.NATIONAL_ID },
                { value: IdTypes.PASSPORT, label: IdTypes.PASSPORT },
            ],
            providers: [ChannelTypes.MOMO],
            phoneValidation: {
                MIN_PHONE_LENGTH: 8,
                MAX_PHONE_LENGTH: 9,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.NATIONAL_ID,
                    regex: '^[0-9]{9}$',
                    captureType: IdCaptureType.FRONT,
                },
                {
                    idType: IdTypes.PASSPORT,
                    regex: '^[A-Z0-9]{9}$',
                    captureType: IdCaptureType.FRONT,
                },
            ],
        },
        CD: {
            countryCode: CountryCodes.DEMOCRATIC_REPUBLIC_OF_CONGO,
            currency: 'CDF',
            countryName: Countries.DEMOCRATIC_REPUBLIC_OF_CONGO,
            idTypes: [{ value: IdTypes.PASSPORT, label: IdTypes.PASSPORT }],
            providers: [ChannelTypes.MOMO],
            phoneValidation: {
                MIN_PHONE_LENGTH: 8,
                MAX_PHONE_LENGTH: 10,
            },
            idTypeValidation: [
                {
                    idType: IdTypes.PASSPORT,
                    regex: '^OP[0-9]{6,10}$',
                    captureType: IdCaptureType.FRONT,
                },
            ],
        },
    };
})(CountryTypes || (CountryTypes = {}));
